export default {
    matomo: {
        intro: 'If you do not agree to the storage and analysis of this data from your visit, then you can revoke your consent to the storage and use at any time by clicking on the switch below. In this case Matomo will not collect any session data.',
        active: {
            label: 'Matomo is active',
            tooltip: 'Click to deactivate Matomo'
        },
        inactive: {
            label: 'Matomo is inactive',
            tooltip: 'Click to activate Matomo'
        }
    }
}
